import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export class ImageValidators {
  public static imageFormat(fileType: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let file: any = control.value;
      if (file === null) return null;
      if (typeof file == 'string') return null;
      let formats = fileType.split(',');
      let filetype: string = file.name.split('.').at(-1).toLowerCase();
      if (formats.find((i) => i == filetype) == undefined)
        return {
          invalidFileType: {
            invalidFileType: true,
            requiredType: fileType.split('image/').join(''),
          },
        };
      return null;
    };
  }

  public static pdfFormat(fileType: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let file: File = control.value;
      if (file === null) return null;
      if (typeof file == 'string') return null;
      let formats = fileType.split(',');
      let filetype: string = file.type.toLowerCase();
      if (formats.find((i) => i == filetype) == undefined)
        return {
          invalidFileType: {
            invalidFileType: true,
            requiredType: fileType.split('image/').join(''),
          },
        };
      return null;
    };
  }

  public static sizeCheck(fileSize: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let file: any = control.value;
      if (typeof file == 'string') return null;
      if (file != null) {
        if (+file.size > +fileSize)
          //in MB
          return {
            invalidFileSize: {
              invalidFileSize: true,
              requiredSize: +fileSize,
            },
          };
      }
      return null;
    };
  }
}
